import SmoothScroll from '@/components/SmoothScroll';
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import Hero from '@/sections/Hero';
import Problem from '@/sections/Problem';
import Ritual from '@/sections/Ritual';
import Collections from '@/sections/Collections';
import Challenge from '@/sections/Challenge';
import ProductDetail from '@/sections/ProductDetail';
import LifestyleGallery from '@/sections/LifestyleGallery';
import BrandStory from '@/sections/BrandStory';
import FutureVision from '@/sections/FutureVision';
import Waitlist from '@/sections/Waitlist';

export default function Landing() {
  return (
    <>
      <SmoothScroll />
      <Nav />
      <main className="bg-[#FAF8F4] text-[#111] font-body antialiased">
        <Hero />
        <Problem />
        <Ritual />
        <Collections />
        <Challenge />
        <ProductDetail />
        <LifestyleGallery />
        <BrandStory />
        <FutureVision />
        <Waitlist />
      </main>
      <Footer />
    </>
  );
}
